import ReactQuill from 'react-quill';

const BlockEmbed = ReactQuill.Quill.import('blots/block/embed');

class WaveLine extends BlockEmbed {
  static create() {
    let node = document.createElement('hr');
    node.setAttribute('wave-line', 'wave-line'); // добавляем атрибут
    node.classList.add('wave-line'); // добавляем класс
    // CSS стили для волнистой линии можно добавить позже в вашем файле стилей
    return node;
  }
}
WaveLine.blotName = 'wave-line';
WaveLine.tagName = 'hr';

export default WaveLine;
